// announcement-ticker.js
(function () {
  // Wait for DOM ready
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    try {
      var container = document.querySelector('.announcement-bar__message .ticker-track');
      if (!container) return;

      // If slider/carousel exists or there are multiple blocks, bail out
      var slider = document.querySelector('.announcement-bar .slider');
      if (slider) return;

      // Ensure there are exactly 2 children (we duplicated via Liquid)
      var items = container.querySelectorAll('.ticker-item');
      if (items.length < 2) {
        // If not duplicated, duplicate first item
        var first = container.innerHTML;
        container.innerHTML = first + first;
        items = container.querySelectorAll('.ticker-item');
      }

      // Force reflow to calculate widths
      function setupTicker() {
        // Reset any previous animation style tag
        var existing = document.getElementById('announcement-ticker-keyframes');
        if (existing) existing.remove();

        // Measure width of the full track (both repeats)
        // We want to move left by width/2 (one copy width)
        var track = container;
        var copyWidth = 0;
        for (var i = 0; i < items.length / 2; i++) {
          copyWidth += items[i].getBoundingClientRect().width;
        }

        // Minimal guard
        if (copyWidth <= 1) return;

        // Choose a speed (px per second). Adjust for faster/slower.
        var pxPerSecond = 140; // higher = faster; tune to taste
        var duration = Math.max(8, Math.round(copyWidth / pxPerSecond)); // seconds, min 8s

        // Build keyframes using pixel value to avoid % rounding issues
        var style = document.createElement('style');
        style.id = 'announcement-ticker-keyframes';
        style.type = 'text/css';

        var keyframes = '\
@keyframes announcementTickerMove {\
  0% { transform: translateX(0px); }\
  100% { transform: translateX(-' + copyWidth + 'px); }\
}\
';

        // Insert animation on the container
        var css = '\
/* injected ticker animation */\n' +
keyframes +
'.ticker-track { animation: announcementTickerMove ' + duration + 's linear infinite; }';

        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
      }

      // Setup initially
      setupTicker();

      // Recompute on resize (debounced)
      var resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(setupTicker, 150);
      });

      // Also re-run if fonts load late or content changes (small safety)
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(setupTicker).catch(function () {});
      }
    } catch (e) {
      // fail silently
      console.error('Ticker init error', e);
    }
  });
})();
